// extracted by mini-css-extract-plugin
module.exports = {"intro":"snippet_intro__mTCwg","backToProgramLink":"snippet_backToProgramLink__3bn61","translations":"snippet_translations__vwd-J","fade-in":"snippet_fade-in__3x40u"};